$(document).ready(function() {

    Shopify.formatMoney = function(cents, format) { 
        if (typeof cents == 'string') { cents = cents.replace('.',''); }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || money_format);

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal   = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch(formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    };
 document.addEventListener('shopify:section:load', function (event){ 
        SectionLoadGroupProduct();
        SectionLoadBoughtTogether();
    });

    function SectionLoadGroupProduct() {
        if ($(".group-product-main").length > 0) {
            let subtotal = 0

            for (const element of document.querySelectorAll(".group-item")) {
              const quantity = element.querySelector(".quantity-input").value
              const price = Number(element.querySelector(".group-product-variant-option").getAttribute("data-price").replace(",", ""))
              subtotal += price * quantity
            }
          
            $('.subtotal span').attr("data-subtotal", subtotal)
            $('.subtotal span').text(Shopify.formatMoney(subtotal*100));
        }
    }

    SectionLoadGroupProduct();
    SectionLoadBoughtTogether();
    function SectionLoadBoughtTogether() {
        // bought together on load subtotal add
        if ($(".bought-together").length > 0) {
            const allselectedElementOnload = document.querySelectorAll(".bought-together-varinat-option"),
            discountRate = Number(document.querySelector(".product-total").getAttribute("data-discount"));
            let subtotalOnload = 0
            allselectedElementOnload.forEach(function(selectItem, selectItemIndex){
              const sum = Number(selectItem.getAttribute('data-price').replace(",", ""));
              subtotalOnload +=  sum
            });
            const finalPrice = subtotalOnload * ( (100-discountRate) / 100 )
            $('.final-price span').attr("data-subtotal", Shopify.formatMoney(finalPrice*100));
            $('.final-price span').text(Shopify.formatMoney(finalPrice*100));
            $('.different-price').text(Shopify.formatMoney(subtotalOnload / discountRate*100));
            $('.discount-price span > s').attr("data-discountTotal", Shopify.formatMoney(subtotalOnload*100));
            $('.discount-price span > s').text(Shopify.formatMoney(subtotalOnload*100));
        }

    }
  function applyVariantChangeEvent(productVariant) {
        $('.variant-option', productVariant).on('click', function(event) {
            $(this).siblings().removeClass('selected');
            $(this).addClass('selected');
            var option_value = this.dataset.optionName,
            selectedVariant = productVariant.productInstance.variants.find((variant) => variant.options.indexOf(option_value) !== -1),
            productBox = $(this).closest('.product-box');
            priceBox = productBox[0].querySelector('.price-box') || false;
            if (!selectedVariant) {
                return;
            }
            if (!priceBox) {
                return;
            }
            priceBox.querySelectorAll('.price-item').forEach(function(priceitem) {
                priceitem.classList.add('d-none');
            });
            var price = selectedVariant.price > 0 ? Shopify.formatMoney(selectedVariant.price) : false,
            compare_price = selectedVariant.compare_at_price > 0 ? Shopify.formatMoney(selectedVariant.compare_at_price) : false,
            old_price = priceBox.querySelector('.price-item.old-price') || false,
            special_price = priceBox.querySelector('.price-item.special-price') || false,
            regular_price = priceBox.querySelector('.price-item.regular-price') || false;
            old_price.querySelector('span.price').innerHTML = '<s>' + compare_price + '</s>';
            special_price.querySelector('span.price').innerHTML = price;
            regular_price.querySelector('span.price').innerHTML = price;
            if (price && compare_price && selectedVariant.price < selectedVariant.compare_at_price) {
                old_price.classList.remove('d-none');
                special_price.classList.remove('d-none');
            } else {
                regular_price.classList.remove('d-none');
            }
            var product_slider = productBox.find('.product-image-slider');
            var variant_id = selectedVariant.featured_media.id;
            var newMedia = document.querySelector(
                `[data-meida-img-id="${variant_id}"]`
              );
            if (selectedVariant.featured_image != '') {
                var variantImage = getResizedImage(selectedVariant.featured_image.src, '535x');
                var is_slider = productBox.attr('slider'); 
                if ( typeof is_slider !== 'undefined' && is_slider !== false && is_slider !== 'false') { 
                    var mediaIndex = newMedia.getAttribute('image-index');
                    product_slider[0].swiper.slideTo(mediaIndex - 1,1000,false);   
                } 
                else{
                    productBox.find('.product-image img:not(.hongo-alternate-image)').removeAttr('srcset').attr('src', variantImage); 
                }                                
            }
        });
    }
// Product card style shop-box 
function CardBox() {
  document.querySelectorAll(".product-card-form .quantity-button ").forEach((e => {
    e.addEventListener("click", (event => {
      const quantityBtn = event.target,
      inputQtyElement = quantityBtn.closest(".quantity"),
      productItem = quantityBtn.closest(".product-footer"),
      AddBtnsss = productItem.querySelectorAll(".cart-btn");
      inputQty = productItem.querySelector(".quantity-input").value;
       AddBtnsss.forEach(function(allItem, allItemIndex){
        allItem.setAttribute("data-qty", inputQty)
      });
    }), !1)
  }));
  document.querySelectorAll(".product-card-variant-option").forEach((e => {
    e.addEventListener("change", (e => {
      const selectedElement = e.target,
       productItem = selectedElement.closest(".box-inner"),
       varinatImageUrl = selectedElement.options[selectedElement.selectedIndex].getAttribute("data-image"),
      AddBtn = productItem.querySelectorAll(".cart-btn"),
      variantParice = selectedElement.options[selectedElement.selectedIndex].getAttribute("data-price"),
      varinatImag = productItem.querySelector("image-srcset").querySelector("img:first-child"),
      SpecialPriceElement = productItem.querySelector(".price-item.special-price"),
      RegularPriceElement = productItem.querySelector(".price-item.regular-price"),
      varinatId = selectedElement.options[selectedElement.selectedIndex].getAttribute("value");
      AddBtn.forEach(function(allItem, allItemIndex){
        allItem.setAttribute("data-variant", varinatId);
      });
      SpecialPriceElement.innerHTML = variantParice;
      RegularPriceElement.innerHTML = variantParice;
      varinatImag.removeAttribute("srcset");
      varinatImag.setAttribute("src", varinatImageUrl);
    }), !1)
  }));
}
  
  });